export default function reverseString(source: string) {
  return Array.from(source).reverse().join('');
}
